import actions from '@/core/store/item-processo/actions'
import mutations from '@/core/store/item-processo/mutations'
import state from '@/core/store/item-processo/state'
import getters from '@/core/store/item-processo/getters'

export default { actions, mutations, state, getters }
